module.exports = __webpack_public_path__ + "img/banner.4fd56c32.jpg";